import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: { locationId: string | null } = {
  locationId: null,
};

const setLocationCookie = (state: typeof initialState, action: PayloadAction<string | null>) => {
  state.locationId = action.payload;
};

export const locationSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    setLocationCookie,
  },
});

export default locationSlice;
